/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Unit_Suffix_M2_MonthInputs */

const cs_price_unit_suffix_m2_month = /** @type {(inputs: Price_Unit_Suffix_M2_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²/měs.`)
};

const en_price_unit_suffix_m2_month = /** @type {(inputs: Price_Unit_Suffix_M2_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²/mo`)
};

/**
* | output |
* | --- |
* | "/m²/mo" |
*
* @param {Price_Unit_Suffix_M2_MonthInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const price_unit_suffix_m2_month = /** @type {((inputs?: Price_Unit_Suffix_M2_MonthInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Unit_Suffix_M2_MonthInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price_unit_suffix_m2_month(inputs)
	return cs_price_unit_suffix_m2_month(inputs)
});